import classNames from 'classnames';
import React from 'react';

type Props = {
    name: string;
    fill?: boolean;
    extraClass?: string;
};

/*
    Icon names can be found here:
    https://fonts.google.com/icons?selected=Material+Icons
*/
const MaterialIcon = ({ name, extraClass, fill = false }: Props): JSX.Element => (
    <i
        className={classNames(
            {
                'material-icons-outlined': !fill,
                'material-icons': fill,
            },
            extraClass
        )}
    >
        {name}
    </i>
);
export default MaterialIcon;
